var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Helpers from "../helpers/utility";
var propValuesForArgList = Helpers.propValuesForArgList;
/**
 * Like lodash bindAll, but can take a function as with bindAll, and also can assign the bound methods
 * to another object instead of monkey patching the original.
 *
 * @param {any} target The target to assign each bound method
 * @param {any} source The context to bind to each
 * @param {any} context The context to bind to each
 * @param {...any} args Things to bind: strings, or an array, or a function invoked for each method name
 * @returns {any} The bound object
 */
export default function bindAssign(target, source, context) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    var arr = propValuesForArgList.apply(void 0, __spreadArrays([source], args));
    return arr
        .reduce(function (last, _a) {
        var prop = _a[0], value = _a[1];
        if (typeof value === 'function') {
            last[prop] = value.bind(context);
        }
        return last;
    }, target);
}
//# sourceMappingURL=bind-assign.js.map